const R = (s) => new RegExp(`^${s}$`);
const ID = "[^/]+";

export const GLOBAL = new Set(["/auth/me", "/billing/me", "/universes", "/writing/stats", "/notifications", "/invites/mine", "/library/continue", "/panel-presets"]);
export const GLOBAL_EMPTY = new Set(["/notifications", "/invites/mine", "/library/continue"]);

export const QUEUEABLE = {
  post: [
    R(`/universes/${ID}/(entities|scenes|timelines|events|calendars|jumps|languages|categories)`),
    R(`/drafts/${ID}/items`), R(`/calendars/${ID}/events`), R(`/maps/${ID}/(pins|regions)`),
    R(`/languages/${ID}/(words|glyphs)`), R(`/regions/${ID}/stages`),
  ],
  patch: [
    R(`/(entities|items|stories|scenes|timelines|events|calendars|calendar-events|jumps|maps|pins|regions|languages|words|glyphs|quotes|relationships)/${ID}`),
    R(`/regions/${ID}/stages/${ID}`), R(`/universes/${ID}`), R(`/maps/${ID}/grid`), R(`/stories/${ID}/meta`),
  ],
  put: [
    R(`/drafts/${ID}/order`), R(`/languages/${ID}/glyphs/order`), R(`/entities/${ID}/images`),
    R(`/universes/${ID}/(relationship-layout|relationship-types)`),
  ],
  delete: [
    R(`/(entities|items|stories|scenes|timelines|events|calendars|calendar-events|jumps|maps|pins|regions|languages|words|glyphs|quotes)/${ID}`),
    R(`/regions/${ID}/stages/${ID}`), R(`/universes/${ID}/categories/${ID}`),
  ],
};

export const EMPTY_OK = [
  R(`/entities/${ID}/(quotes|words|dismissed-flags|comments|history)`), R(`/items/${ID}/(suggestions|review-history)`),
  R(`/languages/${ID}/word-suggestions`), R(`/universes/${ID}/(suggestions|dismissed-suggestions|activity|invites|shareable-stories)`),
];
export const EMPTY_OBJ = [R(`/universes/${ID}/comment-counts`)];
export const PATH_FALLBACK = [R(`/stories/${ID}/stats`), R(`/universes/${ID}/quotes`), R(`/universes/${ID}/entities`), R(`/entities/${ID}/age`)];

export const NOUN = {
  entities: "note", items: "chapter", stories: "story", scenes: "scene", timelines: "timeline", events: "event", calendars: "calendar",
  "calendar-events": "calendar event", jumps: "time jump", maps: "map", pins: "map pin", regions: "map region", stages: "region stage",
  languages: "language", words: "word", glyphs: "glyph", quotes: "quote", relationships: "relationship", categories: "category", universes: "universe",
  drafts: "draft order", grid: "map painting", meta: "book details", images: "images", "relationship-layout": "relationship layout", "relationship-types": "relationship types", order: "order",
};

export const PARENT = { universes: "universe_id", drafts: "draft_id", maps: "map_id", languages: "language_id", calendars: "calendar_id", stories: "story_id", timelines: "timeline_id", regions: "region_id" };

export const matches = (list, path) => (list || []).some((r) => r.test(path));
